import React, { useEffect, useState } from 'react';
import { Redirect, Link } from "react-router-dom";
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
//import { LockClosedSharp } from 'react-ionicons';
import { FaLock } from "react-icons/fa";


const Login = () => {
    //NOTE: We should implement a history redirect, instead of static redirect back to '/Home'.  This way users trying to access eg. '/articles' who did not login will be redirected to '/login'.  After successful login, user should be redirected back to '/articles'.
    const loginState = useSelector(state => state.currentLogin);  //consolidated new Redux login state  
    const messageState = useSelector(state => state.message);  //get data from redux store
    const dispatch = useDispatch();                //Assign dispatch so we can use it...
    const [username, setUsername] = useState('');  //local hooks
    const [password, setPassword] = useState('');  //local hooks

    const dataPost = { username: username, password: password }

    useEffect(() => {
        dispatch({ type: 'SYSMESSAGE', message: '' });
    }, [dispatch]);

    const submitLogin = () => {
        //1. call for Axios.post to submit the credentails to '/person/auth', 
        //2. then get token, and redirect to Home page
        //3. If auth fails, set error to redux (sysmessage) and display here...
        axios.post('/person/auth', dataPost)
        .then((res) => {  
            //set successful returned items to localstorage
            localStorage.setItem('userid', res.data.id);  
            localStorage.setItem('username', res.data.username);  
            localStorage.setItem('firstName', res.data.firstName); 
            localStorage.setItem('lastName', res.data.lastName); 
            localStorage.setItem('token', res.data.token);  
            localStorage.setItem('isLoggedIn', true); //for localStorage need to set this manually to 'true', upon successful login 

            //set successful returned items to redux state too.
            dispatch({ type: 'LOGIN', userid: res.data.id, username: res.data.username, token: res.data.token, firstName: res.data.firstName, lastName: res.data.lastName });
            dispatch({ type: 'SYSMESSAGE', message: '' });

             //Post LoginRecord
            axios.post('/person/createLoginRecord', {"userid": res.data.id, "device": "w"}, { headers: { Authorization: res.data.token } })  //Post to LoginRecord upon successful login
            .then((resLoginRecord) => {
                console.log('{***} LoginRecord Posted: ', resLoginRecord.data);
            }).catch (err => {
                console.log('{***} Error posting LoginRecord: ', err);
            });
            
            console.log('🔐 Login Success');
        }).catch (err => {
            //console.log('❌ Login Error');
            //console.log('Axios error.response:', err.response.data.message);  // will be undefined if no HTTP response
            //dispatch({ type: 'SYSMESSAGE', message: err.response.data.message, messageType: 'alert alert-danger' });

            console.error('❌ Login Error');
            // 🔒 SAFE HANDLING — only inspect err.response if it exists
            if (err.response) {
                const msg = err.response.data?.message || 'Login failed.';
                dispatch({
                type: 'SYSMESSAGE',
                message: msg,
                messageType: 'alert alert-danger'
                });
                console.error('Server returned:', err.response.status, msg);
            } else if (err.request) {
                const msg = 'Unable to contact server. Please check your connection or try again later.';
                dispatch({
                type: 'SYSMESSAGE',
                message: msg,
                messageType: 'alert alert-warning'
                });
                console.error('Network error:', err.message);
            } else {
                const msg = 'Unexpected error occurred.';
                dispatch({
                type: 'SYSMESSAGE',
                message: msg,
                messageType: 'alert alert-danger'
                });
                console.error('Error:', err.message);
            }


        });
    }

    //if(isLogged){  //redirect if redux state is set to loggedin...
    if(loginState.isLoggedIn){
        return <Redirect to={'/'}/>;
    }

    /*
    if(loginState.isLoggedIn){  //redirect if redux state is set to loggedin...
        return <Redirect to={'/'}/>;
    }*/

    let printMessage = '';
    if(messageState.message){
        printMessage = (
            <div className={messageState.messageType} role="alert">
                {messageState.message}
            </div>
        )
    }

    return(
        <div style={{ marginTop: 50 }}>
            <div className="form-login">
                <h3 className="h3 mb-3 fw-normal">Login <FaLock /></h3>
                {printMessage}
                <div className="form-floating">
                    <input type="username" className="form-control" id="floatingInput" placeholder="Email" 
                        onChange={event => setUsername(event.target.value)} />
                    <label>Email</label>
                </div>
                <div className="form-floating">
                    <input type="password" className="form-control mb-4" placeholder="Password" 
                        onChange={event => setPassword(event.target.value)} />
                    <label>Password</label>
                </div>
                <div><button onClick={ ()=> submitLogin()} className="mb-1 w-100 btn btn-lg btn-primary">Login</button></div>
                <br />
                <div className="forget-password-link"><Link to={`/forgot`}>Forgot password?</Link></div>
            </div>
        </div> 
    );
}
export default Login;